module.exports = "<navbar></navbar>\n<sidenav></sidenav>\n<div class=\"content\">\n  <router-outlet></router-outlet>\n  <div class=\"footer\">\n    Powered by <img src=\"assets/images/wise-footer.png\" />\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/wiserisk-core/src/main/ng4app/src/app/components/site/site.component.html
// module id = ../../../../../src/app/components/site/site.component.html
// module chunks = main